module.exports = function() {
  return new Worker(__webpack_public_path__ + "b9048d6ee7f49fdbb4fd.worker.js");
};